import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft, Search } from 'lucide-react';
import { useSEO } from '../hooks/useSEO';

export const NotFound = () => {
  useSEO('notFound');

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center">
        {/* 404 Number */}
        <div className="relative">
          <h1 
            className="text-[180px] sm:text-[220px] font-bold text-[#264F77]/10 leading-none select-none"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            404
          </h1>
          <div className="absolute inset-0 flex items-center justify-center">
            <Search className="w-20 h-20 sm:w-24 sm:h-24 text-[#264F77]/30" />
          </div>
        </div>

        {/* Message */}
        <h2 
          className="text-2xl sm:text-3xl font-semibold text-[#264F77] mb-4 -mt-8"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Seite nicht gefunden
        </h2>
        <p className="text-gray-600 mb-8 text-lg">
          Die von Ihnen gesuchte Seite existiert leider nicht oder wurde verschoben.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center px-6 py-3 bg-[#264F77] text-white font-semibold rounded-lg hover:bg-[#1e3d5c] transition-all duration-300 shadow-md hover:shadow-lg min-h-[48px]"
            aria-label="Zurück zur Startseite"
          >
            <Home className="w-5 h-5 mr-2" />
            Zur Startseite
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center px-6 py-3 bg-white text-[#264F77] font-semibold rounded-lg border-2 border-[#264F77] hover:bg-[#264F77]/5 transition-all duration-300 min-h-[48px]"
            aria-label="Zurück zur vorherigen Seite"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Zurück
          </button>
        </div>

        {/* Helpful Links */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-gray-500 mb-4">Vielleicht finden Sie hier, was Sie suchen:</p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/projekte" className="text-[#264F77] hover:underline">Projekte</Link>
            <span className="text-gray-300">|</span>
            <Link to="/ueber-uns" className="text-[#264F77] hover:underline">Über uns</Link>
            <span className="text-gray-300">|</span>
            <Link to="/blog" className="text-[#264F77] hover:underline">Blog</Link>
            <span className="text-gray-300">|</span>
            <Link to="/kontakt" className="text-[#264F77] hover:underline">Kontakt</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
